import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import s from './InputFieldOutline.scss';
/** The outline and background for our input fields.  */ const InputFieldOutline = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { outlineStyle, className, children } = _param, rest = _object_without_properties(_param, [
        "outlineStyle",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        ref: ref,
        className: c(s['root'], outlineStyle === 'success' && s['success'], outlineStyle === 'error' && s['error'], outlineStyle === 'disabled' && s['disabled'], className)
    }, rest), children);
});
InputFieldOutline.displayName = 'InputFieldOutline';
export default InputFieldOutline;
